import React, { useEffect, useState } from 'react';
import DateRange from '../../../containers/dashboard/DateRange';
import { httpRequestGet, toaster } from "../../../utils/utils";
import { useDispatch } from 'react-redux';
import apiConstants from "../../../constans/apiConstants";
import DataTable from '../../Table';
const IVCReport = () => {
    const [data, setData] = useState([])
    const dispatch = useDispatch();
    const applyDateRange = (startDate, endDate) => {
        const path = `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/data/ivcReport?${'fromDate=' + startDate + '&toDate=' + endDate}`;
        dispatch({ type: 'LOADER_TRUE' });
        httpRequestGet(path).then((res) => {
            dispatch({ type: 'LOADER_FALSE' })
            if (res && res.data) {
                setData(res.data.body?.content)
                toaster('success', res.data.message)
            }
        }).catch((err) => {
            dispatch({ type: 'LOADER_FALSE' });
            if (err && err.data) {
                toaster('error', err.data.message)
            }
        });
    }
    return (
        <>
            <div className="date-range">
                <DateRange
                    applyDateRange={applyDateRange}
                />
            </div>
            {data && data.length > 0 &&
                <>
                   <DataTable
                   cellHeaders={["Proposal No", "Policy No", "IVC status", "Video received", "PDF Received", "IVC Triggered Date", "IVC complete Date"]}
                   data={data}
                   keys={["Proposal Number", "Policy Number","IVC Status", "Video Received", "PDF Received", "IVC Triggered Date", "IVC Completed Date"]}
                   fileName="IVC Report"
                   addSerialNo={true}
                   convertValueToString={true}
                   showExcelDownload={true}
                   PerPageApiData={false}
                   paginationItems={data}
                   alwaysShown={false}
                   />
                   
                </>
            }
        </>
    )
}

export default IVCReport;
